export const API6_ERROR = 'API6_ERROR'
export const API5_ERROR = 'API5_ERROR'
export const CATCH_NETWORK_ERROR = 'CATCH_NETWORK_ERROR'
export const MANUAL_ERROR = 'MANUAL_ERROR'
